// extracted by mini-css-extract-plugin
export default {"chartContainer":"TopAssigneeChart-module_chartContainer_d6fdd3f9","fullScreenChart":"TopAssigneeChart-module_fullScreenChart_ab4508d2"};